<div class="modal-header">
  <h5 class="w-100">
    <strong>{{ 'map.sidebar.trasmissione_antea.credentials_dialog.title' | translate }}</strong>
  </h5>
</div>

<div class="modal-body">
  <form [formGroup]="form" class="d-flex flex-column">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'map.sidebar.trasmissione_antea.credentials_dialog.username' | translate }}</mat-label>
      <input matInput formControlName="username" [disabled]="submitting" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'map.sidebar.trasmissione_antea.credentials_dialog.password' | translate }}</mat-label>
      <input matInput type="password" formControlName="password" [disabled]="submitting" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'map.sidebar.trasmissione_antea.credentials_dialog.client_id' | translate }}</mat-label>
      <input matInput formControlName="clientId" [disabled]="submitting" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'map.sidebar.trasmissione_antea.credentials_dialog.client_secret' | translate }}</mat-label>
      <input matInput type="password" formControlName="clientSecret" [disabled]="submitting" />
    </mat-form-field>
  </form>
</div>

<div class="d-flex justify-content-end align-items-center mt-3">
  <button mat-button [disabled]="submitting" (click)="dialogRef.close()">
    {{ 'common.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" [disabled]="submitting" (click)="submit()">
    {{ 'map.sidebar.trasmissione_antea.credentials_dialog.login' | translate }}
  </button>
</div>
